import _assign from "object-assign";
import React from 'react';
import classnames from 'classnames';
import { Icon } from '@jpmuitk/icon';
import { Tooltip } from '@jpmuitk/tooltip';

var getStateIconClass = function getStateIconClass(state, classes) {
  switch (state) {
    case 'error':
      {
        return classes.iconError;
      }

    case 'warning':
      {
        return classes.iconWarning;
      }

    case 'success':
      {
        return classes.iconSuccess;
      }

    default:
      {
        return classes.iconInfo;
      }
  }
};

var icons = {
  error: 'error-solid',
  success: 'tick',
  warning: 'warning-solid',
  info: 'info-solid'
};

var getStateIcon = function getStateIcon(state) {
  return state ? icons[state] : icons.info;
};

export var StatusIndicator = function StatusIndicator(props) {
  var _props$TooltipCompone = props.TooltipComponent,
      TooltipComponent = _props$TooltipCompone === void 0 ? Tooltip : _props$TooltipCompone,
      _props$hasTooltip = props.hasTooltip,
      hasTooltip = _props$hasTooltip === void 0 ? false : _props$hasTooltip,
      TooltipProps = props.TooltipProps,
      iconProps = props.IconProps,
      state = props.state,
      _props$classes = props.classes,
      classes = _props$classes === void 0 ? {} : _props$classes,
      style = props.style;
  var icon = /*#__PURE__*/React.createElement("span", {
    style: _assign({
      height: 0
    }, style)
  }, /*#__PURE__*/React.createElement(Icon, _assign({
    classes: {
      root: classnames(classes.iconRoot, getStateIconClass(state, classes))
    },
    name: getStateIcon(state)
  }, iconProps)));
  return hasTooltip ? /*#__PURE__*/React.createElement(TooltipComponent, _assign({
    PopperProps: {
      modifiers: {
        flip: {
          enabled: false
        }
      }
    },
    classes: {
      tooltipRoot: classes.tooltipRoot,
      stateIcon: classes.stateIcon,
      stateIconContainer: classes.stateIconContainer
    },
    hasIcon: false,
    placement: "top",
    state: state
  }, TooltipProps), /*#__PURE__*/React.createElement("span", null, icon)) : icon;
};
export default StatusIndicator;
//# sourceMappingURL=StatusIndicator.js.map